import { BehaviorSubject } from "rxjs";

export const APP_INFOS = { app_name: 'coop_finance_backoffice', app_commit_sha: '18db7dcfd1f0', app_version: '2026.0716.2120' };
export const API_INFOS$ = new BehaviorSubject({ app_name: '', app_commit_sha: '18db7dcfd1f0', app_version: '2026.0716.2120' });